import guardrailLogo from '@/assets/white-horizontal.svg';
import { format } from 'date-fns';

interface ReportFooterProps {
  generatedDate?: Date;
  showPrintInfo?: boolean;
}

const ReportFooter = ({ generatedDate, showPrintInfo = true }: ReportFooterProps) => {
  const displayDate = generatedDate || new Date();
  const formattedDate = format(displayDate, "MMMM d, yyyy 'at' h:mm a");

  return (
    <>
      {/* Regular footer visible on screen */}
      <footer className="mt-12 pt-6 border-t border-zinc-800 print-hide">
        <div className="flex items-center justify-between text-sm text-zinc-400">
          <div className="flex items-center gap-3">
            <img
              src={guardrailLogo}
              alt="AI Traffic Light"
              className="h-8 w-auto opacity-70"
            />
            <div className="flex flex-col">
              <span className="text-white">
                © {new Date().getFullYear()} Guardrail Technologies
              </span>
              <span className="text-xs text-zinc-500">Generated: {formattedDate}</span>
            </div>
          </div>

          <span className="px-2 py-1 bg-zinc-800 rounded text-xs uppercase tracking-wider font-medium text-zinc-300">
            Confidential
          </span>
        </div>
      </footer>

      {/* Print-only footer that appears on each page */}
      {showPrintInfo && (
        <div className="print-footer-container">
          <div className="print-footer">
            <div className="print-footer-content">
              <span className="print-footer-left">
                © {new Date().getFullYear()} Guardrail Technologies | Confidential
              </span>
              <span className="print-footer-center">Generated: {formattedDate}</span>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportFooter;
